module.exports = __webpack_public_path__ + "static/media/getaroom.c1ef81f5.svg";